import React, { useContext, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { CNavItem, CSidebar, CSidebarBrand, CSidebarNav } from '@coreui/react'
import CIcon from '@coreui/icons-react'

import { AppSidebarNav } from './AppSidebarNav'

import SimpleBar from 'simplebar-react'
import 'simplebar/dist/simplebar.min.css'
import '../../scss/style.scss'
import ottdock_logo from '../../assets/ott_dock-dark.png'

// sidebar nav config
import navigation from './_nav'
import { GlobalContext } from '../../views/context/GlobalState'
import { cilPeople, cilSpeech } from '@coreui/icons'
import { isEmpty } from 'lodash'
import { checkPermissions } from '../../views/utils/helper'

const AppSidebar = () => {
  const dispatch = useDispatch()
  const { signedIn, userObj, userSessionObj } = useContext(GlobalContext)
  const unfoldable = useSelector((state) => state.sidebarUnfoldable)
  const sidebarShow = useSelector((state) => state.nav.sidebarShow)
  const [navigationList, setNavigationList] = useState()
  const sidebarMainClasses =
    'sidebar-bg sidebar-color sidebar-width sidebar-border-width sidebar-border-color '
  const sidebarHeaderClasses = 'sidebar-brand-bg sidebar-brand-color sidebar-brand-height '
  const sidebarNavClasses =
    'sidebar-nav-title-color sidebar-nav-link-color sidebar-nav-link-icon-color sidebar-nav-link-active-color sidebar-nav-link-active-icon-color sidebar-nav-link-hover-color sidebar-nav-link-hover-icon-color sidebar-nav-link-hover-bg '

  const classes = sidebarMainClasses + sidebarHeaderClasses + sidebarNavClasses

  const getFilteredNavigation = () => {
    const permissions = userSessionObj.session_data.permissions
    const newNavigation = []
    navigation.forEach((nav) => {
      if (nav.permission) {
        if (checkPermissions(permissions, nav.permission)) {
          newNavigation.push(nav)
        }
      } else {
        if (nav.items) {
          const newItems = []
          nav.items.forEach((item) => {
            if (item.permission) {
              if (checkPermissions(permissions, item.permission)) {
                newItems.push(item)
              }
            } else {
              newItems.push(item)
            }
          })
          if (!isEmpty(newItems)) {
            newNavigation.push({ ...nav, items: newItems })
          }
        } else {
          newNavigation.push(nav)
        }
      }
    })
    return newNavigation
  }

  useEffect(() => {
    if (signedIn && userObj) {
      setNavigationList(
        userObj.is_super_user
          ? [
              {
                component: CNavItem,
                name: 'Manage Account',
                icon: <CIcon icon={cilSpeech} customClassName="nav-icon" />,
                to: '/manage-accounts',
              },
              {
                component: CNavItem,
                name: 'Manage Leads',
                icon: <CIcon icon={cilPeople} customClassName="nav-icon" />,
                to: '/manage-leads',
              },
            ]
          : getFilteredNavigation(),
      )
    }
  }, [signedIn])

  return (
    <CSidebar
      className={classes}
      position="fixed"
      selfHiding="md"
      // size='sm'
      // colorScheme='light'
      unfoldable={unfoldable}
      visible={sidebarShow}
      onHide={() => {
        dispatch({ type: 'set', sidebarShow: false })
      }}
    >
      <CSidebarBrand className="d-none d-md-flex" to="/">
        <div>
          <img src={ottdock_logo} alt="logo" height={35} />
        </div>
      </CSidebarBrand>
      <CSidebarNav>
        {signedIn && navigationList && (
          <SimpleBar>
            <AppSidebarNav items={navigationList} />
          </SimpleBar>
        )}
      </CSidebarNav>
    </CSidebar>
  )
}

export default React.memo(AppSidebar)
